import { BODY_SM_SM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const ToggleSwitchWrapper = styled.div<{ $isFixed: boolean; $isCentered?: boolean; $isColumn?: boolean }>`
    ${({ $isFixed }) =>
        !$isFixed &&
        `
            display: flex;
            align-items: center;
            gap: 8px;
        `}

    ${({ $isCentered }) => $isCentered && 'justify-content: center;'}
    ${({ $isColumn }) => $isColumn && 'flex-direction: column;'}
    
    button[role='switch'] {
        .ant-switch-handle::before {
            background: var(--colors-surface-primary, #fff) !important;
        }
    }
    button[role='switch'][aria-checked='false'] {
        background: var(--colors-surface-primary, #fff) !important;
        border: var(--border-width-sm_1, 1px) solid var(--colors-border-action, #2171c6);
        border-radius: var(--border-radius-round, 48px);

        .ant-switch-handle {
            top: 2px;
            left: 3px;
        }

        .ant-switch-handle::before {
            background: var(--colors-surface-action, #2171c6) !important;
        }
    }
    button[role='switch'][aria-checked='true'] {
        background: var(--colors-surface-action, #2171c6) !important;
    }
`;

export const ToggleSwitchState = styled.div<{ $isActive: boolean }>`
    ${BODY_SM_SM_STYLES};
    color: var(--colors-text-body, #50566e);
    font-weight: ${({ $isActive }) => ($isActive ? 700 : 400)};
`;
